/*global Modernizr, Splide, TLASlideCurrentSlide, TLASlideHideArrows, TLASlideDisableDrag */
/*jslint browser:true */

(function() {
    'use strict';

    var alert_slider = document.getElementById('alert-slider');
    if(alert_slider) {
      var close_alert = alert_slider.querySelector('.alerts-close');

      const slider = new Splide(alert_slider, {
        type: 'loop',
        pagination: false
      });

      slider.on('mounted resize', () => {
        if(slider.length <= slider.options.perPage) {
          slider.root.querySelector('.splide__arrows').classList.add('page-less');
        } else {
          slider.root.querySelector('.splide__arrows').classList.remove('page-less');
        }
      });

      slider.on('mounted', () => {
        setTimeout(() => {
          slider.refresh();
        }, 200);
      });

      slider.mount({ TLASlideCurrentSlide, TLASlideDisableDrag });

      close_alert.addEventListener('click', (e) => {
        e.preventDefault();

        document.cookie = 'TLAClosedAlerts=true; max-age='+(12*60*60)+'; SameSite=lax; path=/';

        alert_slider.parentNode.remove();
        document.body.classList.add('alerts-closed');
      });
    }
}());
